import { useCallback, useRef } from 'react';

import { getWatermarkKey, maxTimestamp } from '@/shared/lib/commentWatermarkUtils';

import { WatermarkScope } from './useSessionStableWatermarks.constants';

export const useSessionStableWatermarks = () => {
  const watermarkSnapshots = useRef<Record<string, string | null>>({});

  const getStableWatermark = useCallback(
    (
      scope: WatermarkScope,
      id1: string,
      id2?: string | null,
      currentWatermark?: string | null,
      storedWatermark?: string | null,
    ) => {
      const key = getWatermarkKey(scope, id1, id2);

      if (!(key in watermarkSnapshots.current)) {
        watermarkSnapshots.current[key] = maxTimestamp(currentWatermark, storedWatermark);
      }

      return watermarkSnapshots.current[key];
    },
    [],
  );

  const clearSnapshot = useCallback((scope: WatermarkScope, id1: string, id2?: string | null) => {
    const key = getWatermarkKey(scope, id1, id2);
    delete watermarkSnapshots.current[key];
  }, []);

  return {
    getStableWatermark,
    clearSnapshot,
    watermarkSnapshots: watermarkSnapshots.current,
  };
};

export default useSessionStableWatermarks;
